import React from "react";
import { useTranslation } from "react-i18next";
import SeoHead from "../seo/SeoHead";
import ServicePage, { RelatedServices, ServiceChecklist, ServiceCta, ServiceFaq, ServiceHero } from "./ServicePageLayout";
import PreRepairImg from "../../assets/pre-repair.png";

const PreRepairDiagnostics = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';
    const lang = i18n.language === 'en' ? 'en' : 'ar';
    const faq = t('repairDiagnosticsPage.faq', { returnObjects: true });

    return (
        <ServicePage isRTL={isRTL}>
            <SeoHead
                path="services/pre-repair-diagnostics"
                title={t('repairDiagnosticsPage.metaTitle')}
                description={t('repairDiagnosticsPage.metaDescription')}
                keywords={t('repairDiagnosticsPage.keywords')}
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: faq.map(({ q, a }) => ({
                        '@type': 'Question',
                        name: q,
                        acceptedAnswer: { '@type': 'Answer', text: a },
                    })),
                }}
            />

            <ServiceHero
                eyebrow={t('repairDiagnosticsPage.eyebrow')}
                title={t('repairDiagnosticsPage.title')}
                intro={t('repairDiagnosticsPage.description').replace(/<\/?strong>/g, '')}
                image={PreRepairImg}
                imageAlt={t('repairDiagnosticsPage.imageAlt')}
                ctaLabel={t('repairDiagnosticsPage.ctaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز تشخيص ما قبل الإصلاح.' : 'Hi, I would like to book a pre-repair diagnostic.'}
            />

            <ServiceChecklist title={t('repairDiagnosticsPage.coverTitle')} points={t('repairDiagnosticsPage.coverPoints', { returnObjects: true })} />
            <ServiceFaq title={t('repairDiagnosticsPage.faqTitle')} items={faq} />
            <RelatedServices title={t('repairDiagnosticsPage.related.title')} items={t('repairDiagnosticsPage.related.items', { returnObjects: true })} lang={lang} />

            <ServiceCta
                eyebrow={t('repairDiagnosticsPage.eyebrow')}
                title={t('repairDiagnosticsPage.title')}
                body={t('repairDiagnosticsPage.metaDescription')}
                ctaLabel={t('repairDiagnosticsPage.ctaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز تشخيص ما قبل الإصلاح.' : 'Hi, I would like to book a pre-repair diagnostic.'}
            />
        </ServicePage>
    );
};

export default PreRepairDiagnostics;
